// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\n  margin: 0;\n}\n\n.cn-next-dialog-body {\n  min-height: 0px !important;\n}\n\n#nc_token {\n  background: rgba(0, 0, 0, 0.5);\n  height: 100vh;\n  width: 100vw;\n  padding-top: 48vh;\n}\n\n#nc_1-stage-1 {\n  max-width: 305px;\n  margin: 0 auto;\n}\n\n#nc_1-stage-3 {\n  background-color: #fff;\n  padding-top: 1px;\n  padding-bottom: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
